import { Post } from "api";
import { call, put, takeEvery } from "redux-saga/effects";
import { CampaignChangesData } from "./reducer";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "request";
import {
  UpdateCampaignChanges,
  UpdateCampaignChangesRequestStateAction,
} from "./action";
import { TransformCampaignChangesResponse } from "./transformer";

export function* overviewSaga() {
  yield takeEvery("overview-request-campaigns", fetchCampaignsOverview);
}

function* fetchCampaignsOverview(action: any) {
  try {
    yield put(UpdateCampaignChangesRequestStateAction(RequestLoadingUpdate));

    let fullUrl = "/manage/campaign-change-log";
    fullUrl += "?page="+ action.offset
    fullUrl += "&limit="+ action.limit

    if(action.partnerId){
      fullUrl += "&partnerId="+action.partnerId
    }

    const response: CampaignChangesData = yield call(
      Post,
      fullUrl,
      {}
    );
    const transformed = TransformCampaignChangesResponse(response);

    yield put(
      UpdateCampaignChanges({
        campaignChanges: transformed,
        totalCampaignChangeCount: response.resultCount,
      })
    );
    yield put(UpdateCampaignChangesRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    console.warn(e);
    yield put(UpdateCampaignChangesRequestStateAction(RequestFailedUpdate));
  }
}
